import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { BookOpen } from 'lucide-react';
import InstructiebladenSection from '@/components/InstructiebladenSection';

export default function Instructiebladen() {
  const { user } = useAuth();
  const isManagerOnly = !['owner', 'admin'].includes(user?.role);

  return (
    <div className="space-y-6 max-w-6xl" data-testid="page-instructiebladen">
      <div className="border-b border-[#e4e9f0] pb-4">
        <h2 className="text-3xl font-bold text-tw1-brand-navy flex items-center gap-2">
          <BookOpen size={26} /> Instructiebladen
        </h2>
        <p className="mt-1 text-sm text-tw1-text-muted">
          {isManagerOnly
            ? 'Upload en beheer instructiebladen voor je eigen locatie(s), zichtbaar voor medewerkers in het portaal.'
            : 'Upload en beheer instructiebladen voor alle locaties, zichtbaar voor medewerkers in het portaal.'}
        </p>
      </div>
      <InstructiebladenSection isManagerOnly={isManagerOnly} />
    </div>
  );
}
